import React, { useEffect, useState, useCallback } from "react";
import './index.scss'
import { getAPi } from "../../api/api";
import { connect } from 'react-redux';
// import { throttle, debounce } from "../../huntplanner-layer-render/map-functions";
import { huntplannerMorefilters } from "../../../../action/huntplanner-morefilters-actions";
import { fetchGetFilterCount } from "../../../../action/huntPlanner-api-actions";
import UpgradeButton from "../huntPlanner-right-toolbar/upgrade-button";
import TableView from "../huntPlanner-right-toolbar/tableView";
import { countNonEmptyKeysExcluding } from "../../reusableComponents/commonFunctions/commonFunctions";
import { huntPlannerActiveOtions } from "../../../../action/huntplanner-selected-options";
import SelectMenu from "../../reusableComponents/selectField/SelectOptions";

const FilterComponent = ({ filterValue, filterPayload, auth, handleFilterFetch, fetchGetFilterCount, huntPlannerActiveOtions, huntPlannerFilterOptions, huntPlannerSelectedOtions, moreFilterOptions, currentObj, huntplannerMorefilters, huntplannerMorefiltersState }) => {
  const [harvestSuccess, setHarvestSuccess] = useState(huntplannerMorefiltersState?.harvestSuccess || 0);
  const [drawOdds, setDrawOdds] = useState(huntplannerMorefiltersState?.drawOdds || 0);
  const [DrawPoints, setDrawPoints] = useState(huntplannerMorefiltersState.DrawPoints || 0);
  const [trophyPotential, setTrophyPotential] = useState(huntplannerMorefiltersState?.trophyPotential || 0);
  const [publicLand, setPublicLand] = useState(huntplannerMorefiltersState?.publicLand || 0)
  const [state, setState] = useState();
  const [DrawChoice, setDrawChoice] = useState(huntplannerMorefiltersState?.DrawChoice || '');
  const [Choice, setChoice] = useState(huntplannerMorefiltersState?.Choice || '')
  const [DrawPercentage, setDrawPercentage] = useState(0)
  const [ExactPoints, setExactPoints] = useState(huntplannerMorefiltersState?.ExactPoints || false)
  const [countFilter, setCountFilter] = useState(0)
  const [filterOptions, setFilterOptions] = useState({
    harvestSuccess: '',
    DrawPoints: 0, // Initialize as needed
    trophyPotential: '',
    publicLand: '',
    method: '',
    season: '',
    sex: '',
    DrawChoice: '',
    Choice: '',
    DrawPercentage: '',
    ExactPoints: ''
  })
  const [openSelect, setOpenSelect] = useState(null); // Track the open select menu

  useEffect(() => {
    if (!huntplannerMorefiltersState) return;
    // Set filter options state
    setFilterOptions({
      harvestSuccess: huntplannerMorefiltersState.harvestSuccess || '',
      DrawPoints: huntplannerMorefiltersState.DrawPoints || 0,
      trophyPotential: huntplannerMorefiltersState.trophyPotential || '',
      publicLand: huntplannerMorefiltersState.publicLand || '',
      method: huntplannerMorefiltersState.method || '',
      season: huntplannerMorefiltersState.season || '',
      sex: huntplannerMorefiltersState.sex || '',
      DrawChoice: huntplannerMorefiltersState.DrawChoice || (!huntplannerMorefiltersState.Choice ? filterValue.drawOdds.drawChoices[0] : ''),
      Choice: huntplannerMorefiltersState.Choice || '',
      ExactPoints: huntplannerMorefiltersState.ExactPoints || false,
      DrawPercentage: huntplannerMorefiltersState.DrawPercentage || ''
    });

    // Individual state setters
    setHarvestSuccess(huntplannerMorefiltersState.harvestSuccess || 0);
    setDrawPoints(huntplannerMorefiltersState.DrawPoints || 0);
    setTrophyPotential(huntplannerMorefiltersState.trophyPotential || 0);
    setPublicLand(huntplannerMorefiltersState.publicLand || 0);


    setChoice(huntplannerMorefiltersState.Choice || 0);
    setDrawPercentage(huntplannerMorefiltersState.DrawPercentage || 0);
    setExactPoints(huntplannerMorefiltersState.ExactPoints || false);

    // Exclude certain keys and count the number of non-empty values
    const excludeKeys = ["StateAbbreviation", "Species", "HuntTypeKey", "unitName", "DrawChoice"];
    const count = countNonEmptyKeysExcluding(huntplannerMorefiltersState, excludeKeys);
    setCountFilter(count);
  }, [huntplannerMorefiltersState]);

  useEffect(() => {
    if (filterValue) {
      const initialState = {
        harvestSuccess: filterValue.harvestSuccess || 0,
        DrawPoints: filterValue.DrawPoints || 0, // Initialize as needed
        trophyPotential: filterValue.trophyPotential || 0,
        publicLand: filterValue.publicLand || 0,
        method: filterValue.weapon,
        season: filterValue.season,
        sex: filterValue.sex,
        drawOdds: filterValue.drawOdds || 0,
        DrawChoice: filterValue.DrawChoice ? filterValue.DrawChoice : !filterValue.Choice ? filterValue?.drawOdds?.drawChoices[0] : '',
        Choice: filterValue.Choice,
        ExactPoints: filterValue.ExactPoints,
        DrawPercentage: filterValue.DrawPercentage
      };
      setState(initialState);
    }
  }, [filterValue]);

  useEffect(() => {
    if (filterValue) {
      const initialState = {
        harvestSuccess: filterValue.harvestSuccess || 0,
        DrawPoints: filterValue.DrawPoints || 0, // Initialize as needed
        trophyPotential: filterValue.trophyPotential || 0,
        publicLand: filterValue.publicLand || 0,
        method: filterValue.weapon,
        season: filterValue.season,
        sex: filterValue.sex,
        drawOdds: filterValue.drawOdds || 0,
        DrawChoice: filterValue?.drawOdds?.drawChoices[0],
        Choice: filterValue.Choice,
        ExactPoints: filterValue.ExactPoints,
        DrawPercentage: filterValue.DrawPercentage
      };
      setState(initialState);
      if (!filterValue.Choice) {
        setDrawChoice(filterValue.drawOdds.drawChoices[0])
        // huntplannerMorefilters({ ...huntplannerMorefiltersState, DrawChoice: filterValue.drawOdds.drawChoices[0] });
      }
    }
    // // Set DrawChoice and Choice
    // if (!huntplannerMorefiltersState.Choice) {
    //   setDrawChoice(filterValue.drawOdds.drawChoices[0]);
    // } else {
    //   setDrawChoice(huntplannerMorefiltersState.DrawChoice || 0);
    // }
  }, []);

  useEffect(() => {
    setDrawChoice(huntplannerMorefiltersState.DrawChoice)
  }, [huntplannerMorefiltersState.DrawChoice])

  const toggleSelect = (name) => {
    setOpenSelect((prev) => (prev === name ? null : name));
  };

  const onChangeOptions = (e, fieldName) => {

    let name = e?.target?.name || fieldName;
    let value = fieldName ? '' : e.target.value;

    // console.log(value, '===========>value')


    setFilterOptions((prevState) => {
      let updatedOptions = {
        ...prevState,
        [name]: value, // Update only the specific field
      };

      // If 'Choice' is selected, reset 'DrawChoice', 'DrawPoints', and 'ExactPoints'
      if (name === 'Choice' && value) {
        updatedOptions = {
          ...updatedOptions,
          DrawChoice: '',
          DrawPoints: '',
          ExactPoints: '',
        };
      }

      // If 'DrawChoice' is selected, reset 'Choice'
      if (name === 'DrawChoice' && value) {
        updatedOptions = {
          ...updatedOptions,
          Choice: '',
          DrawPoints: !updatedOptions.DrawPoints ? 0 : updatedOptions.DrawPoints
        };
      }

      if (name === 'DrawChoice' && e == '') {
        updatedOptions = {
          ...updatedOptions,
          Choice: '',
          DrawPoints: ''
        };
      }

      let options;
      if (
        huntPlannerSelectedOtions.StateAbbreviation &&
        huntPlannerSelectedOtions.Species &&
        huntPlannerSelectedOtions.HuntTypeKey
      ) {
        options = {
          ...filterPayload,
          ...huntPlannerSelectedOtions,
          ...updatedOptions
        };
      } else {
        options = {
          ...filterPayload,
          ...updatedOptions
        };
      }

      // Convert any "0" values to empty strings
      Object.keys(options).forEach((key) => {
        if (options[key] == 0) {
          options[key] = "";
        }
      })

      // Call functions to update filters
      huntplannerMorefilters(options);
      // handleFilterFetch(options, currentObj, false);

      return updatedOptions; // Return updated state
    });
  };

  // Debounce function
  function debounce(func, delay) {
    let timer;
    return function (...args) {
      clearTimeout(timer);
      timer = setTimeout(() => {
        func(...args);
      }, delay);
    };
  }

  // Use useCallback to memoize the debounced function
  const debouncedOnChangeOptions = useCallback(
    debounce(onChangeOptions, 1000),
    [] // Empty dependency array to keep the debounce function stable
  );


  let resetFilter = () => {
    const excludeKeys = ["StateAbbreviation", "Species", "HuntTypeKey", "unitName", "DrawChoice"];
    if (huntPlannerFilterOptions?.huntResearch) {
      // Remove non-excluded keys from selectedOption
      let selectedOption = Object.keys(huntPlannerSelectedOtions)
        .reduce((acc, key) => {
          if (excludeKeys.includes(key)) {
            acc[key] = huntPlannerSelectedOtions[key]; // Keep only excluded keys
          }
          return acc;
        }, {});

      // Update non-excluded keys in morefiltersState with an empty string
      let morefiltersState = Object.keys(huntplannerMorefiltersState)
        .reduce((acc, key) => {
          if (excludeKeys.includes(key)) {
            acc[key] = huntplannerMorefiltersState[key]; // Keep the excluded keys
          } else {
            acc[key] = ''; // Set other keys to an empty string
          }
          return acc;
        }, {});

      // handleFilterFetch(morefiltersState, currentObj, false);
      huntPlannerActiveOtions(selectedOption)  // undefined should also remove
      huntplannerMorefilters(morefiltersState)
    }
  }

  return (
    <>
      <div className="filters-container">
        <div className="filter-header-container">
          <h3>Filters ({countFilter})</h3>
          <p onClick={() => resetFilter()}>Reset</p>
        </div>
        {!huntPlannerFilterOptions?.huntResearch ?
          <UpgradeButton
            label='Unlock Filters'
            className={'upgrade-button-style'}
            discription='Get access to powerful filters and quickly narrow down your options'
          ></UpgradeButton> : null}
        {state &&
          <>
            {/* ----Dropdowns---- */}
            {/* Weapon type */}
            <div className="dropdown" style={{}}>
              <label>Weapon type</label>
              {/* <select name="method" value={filterOptions.method} disabled={!huntPlannerFilterOptions?.huntResearch} onChange={onChangeOptions}>
                <option value="" selected>Any weapon</option>
                {state.method && state.method.map((item, index) => {
                  return <option key={index} value={item}>{item}</option>;
                })}
              </select> */}
              <SelectMenu
                name="method"  // Passed as a prop
                options={state.method || []}
                selectedValue={filterOptions.method}
                disabled={!huntPlannerFilterOptions?.huntResearch}
                onSelect={onChangeOptions}
                defaultOption='Any Weapon'
                isOpen={openSelect === "method"}
                setIsOpen={() => toggleSelect("method")}

              />
            </div>

            {/* Seasons */}
            <div className="dropdown">
              <label>Seasons</label>
              {/* <select name="season" value={filterOptions.season} disabled={!huntPlannerFilterOptions?.huntResearch} onChange={onChangeOptions}>
                <option value="" selected>Any Season</option>
                {state?.season?.map((item) => {
                  return <option value={item}>{item}</option>
                })}
              </select> */}

              <SelectMenu
                name="season" // Passed as a prop
                options={state.season || []}
                selectedValue={filterOptions.season}
                disabled={!huntPlannerFilterOptions?.huntResearch}
                onSelect={onChangeOptions}
                defaultOption='Any Season'
                isOpen={openSelect === "season"}
                setIsOpen={() => toggleSelect("season")}
              />
            </div>

            {/* Sex */}
            <div className="dropdown">
              <label>Sex</label>
              {/* <select name="sex" value={filterOptions.sex} disabled={!huntPlannerFilterOptions?.huntResearch} onChange={onChangeOptions}>
                <option value="">Any Sex</option>
                {state?.sex?.map((item, index) => {
                  return <option key={index} value={item}>{item}</option>
                })}
              </select> */}
              <SelectMenu
                name="sex" // Passed as a prop
                options={state.sex || []}
                selectedValue={filterOptions.sex}
                disabled={!huntPlannerFilterOptions?.huntResearch}
                onSelect={onChangeOptions}
                defaultOption='Any Sex'
                isOpen={openSelect === "sex"}
                setIsOpen={() => toggleSelect("sex")}
              />
            </div>
            {/* -----Dropdowns end----*/}

            {/* Harvest Success Slider */}
            <div className="slider-section">
              <label>Harvest Success</label>
              {/* <div className="toggle-button">Any</div>
                  */}
              <div className="padding-child">
                <div className={!huntPlannerFilterOptions?.huntResearch ? 'toggle-button disable-button disable-button-border-none' : 'toggle-button'} >{harvestSuccess > 0 ? harvestSuccess + "%" : 'Any'}</div>
                <div className="margin-top-bottom-1em">
                  <input
                    type="range"
                    min={state?.harvestSuccess?.min ? state?.harvestSuccess?.min.toFixed(0) : 0}
                    max={state?.harvestSuccess?.max ? state?.harvestSuccess?.max.toFixed(0) : 0}
                    value={harvestSuccess}
                    name="harvestSuccess"
                    className={!huntPlannerFilterOptions?.huntResearch ? 'bg-color-light-gray' : ''}
                    style={{ background: !huntPlannerFilterOptions?.huntResearch ? '#959595' : '' }}
                    disabled={!huntPlannerFilterOptions?.huntResearch}
                    onChange={(e) => {
                      setHarvestSuccess(e.target.value)
                      debouncedOnChangeOptions(e)
                    }}
                  />
                </div>
                <div className="slider-values">
                  <span>{state?.harvestSuccess?.min?.toFixed(0)}</span>
                  <span>{(state?.harvestSuccess?.max)?.toFixed(0)}</span>
                </div>
              </div>
            </div>


            {/* Draw Odds Section */}
            <div className={'draw-odds-section'}
              // style={{ marginTop: DrawChoice ? '15px' : '0px' }}
              style={{ maxHeight: DrawPoints >= 1 ? 500 : 350 }}
            >
              {/* {DrawChoice ? <label style={{ width: '100%' }}>Draw Odds</label> : null} */}
              <label style={{ width: '100%' }}>Draw Odds</label>
              {(state.drawOdds?.points?.length > 0 || state.drawOdds?.choices?.length > 0) &&
                <div style={{ width: '95%' }} className={!huntPlannerFilterOptions?.huntResearch ? "padding-child-draw" : "padding-child"}>
                  {/* Draw Odds /state= DrawPoints */}
                  {DrawChoice ?
                    <>
                      {/* points */}
                      {state.drawOdds?.points.length > 0 &&
                        <>
                          <label>{DrawChoice == 'raffle' ? 'Entries' : 'Points'}</label>
                          <div className="padding-child">
                            <div className="points">
                              {
                                state?.drawOdds?.points.map((point) => {
                                  return (
                                    <div style={{ width: '2.6rem', height: '2.6rem' }}>
                                      <div
                                        name="DrawPoints"
                                        key={point}
                                        className={`${!huntPlannerFilterOptions?.huntResearch ? 'disable-button disable-button-border' : ''} point ${DrawPoints === point || (point == 0 && DrawPoints == 0 && huntPlannerFilterOptions?.huntResearch) ? "active" : ""}`}
                                        onClick={(e) => {
                                          if (huntPlannerFilterOptions?.huntResearch) {
                                            setDrawPoints(point)
                                            setExactPoints(false)
                                            const customEvent = {
                                              target: {
                                                name: "DrawPoints",  // You can set it dynamically if needed
                                                value: point,
                                              }
                                            }
                                            onChangeOptions(customEvent);
                                          }
                                        }}
                                      >
                                        {point}
                                      </div>
                                    </div>
                                  )
                                }
                                )
                              }
                            </div>

                          </div>

                          <label>Odds of drawing with {DrawPoints} {DrawChoice == 'raffle' ? 'entries' : 'points'} </label>
                        </>
                      }
                    </>
                    :
                    null
                  }

                  {/* bar state=drawPercentage */}
                  <>
                    {/* <label style={{ marginBottom: 10 }}>Select your chance of drawing</label> */}
                    <div
                      className={!huntPlannerFilterOptions?.huntResearch ? 'toggle-button disable-button disable-button-border-none' : 'toggle-button'}
                    >{DrawPercentage == 0 ? '>0%' : DrawPercentage + '%'}</div>
                    <div className="margin-top-bottom-1em draw-percentage-slider" style={{ marginBottom: '0em' }}>
                      <div className="input-drawpercentage-div"  >
                        <input
                          name="DrawPercentage"
                          type="range"
                          min="0"
                          max="100"
                          className={!huntPlannerFilterOptions?.huntResearch ? 'bg-color-light-gray' : ''}
                          style={{ background: !huntPlannerFilterOptions?.huntResearch ? '#959595' : '' }}
                          disabled={!huntPlannerFilterOptions?.huntResearch}
                          value={DrawPercentage}
                          onChange={(e) => {
                            setDrawPercentage(e.target.value)
                            debouncedOnChangeOptions(e)
                          }}
                        />
                      </div>

                      <div className="slider-values" style={{ height: '1rem' }}>
                        <span>{'>0%'}</span>
                        <span>100%</span>
                      </div>
                    </div>
                  </>


                  <div className="odd-points-child padding-child">
                    {/* drawChoices state=drawChoice  pref point idhi vuntey anni vundali */}
                    {state.drawOdds?.drawChoices.length > 0 &&
                      <>
                        {state.drawOdds?.drawChoices.map((item, index) => {
                          return (
                            <div className="checkbox" style={{ marginBottom: 10 }} key={index}>
                              <input
                                type="radio"
                                id={`drawChoice-${index}`} // Unique ID
                                checked={String(DrawChoice) === String(item)}
                                name="DrawChoice" // Common name to ensure only one can be selected
                                className={huntPlannerFilterOptions?.huntResearch ? "custom-radio disabled" : "custom-radio"}
                                style={{ cursor: 'pointer' }}
                                disabled={!huntPlannerFilterOptions?.huntResearch}
                                value={item}
                                onChange={(e) => {
                                  setDrawChoice(item); // Make sure `item` is of the correct type here
                                  setChoice('');
                                  !DrawPoints && setDrawPoints(0);
                                  setExactPoints(false);
                                  onChangeOptions(e);
                                }}
                              />
                              <label htmlFor={`drawChoice-${index}`} style={{ marginBottom: 0 }}>{item}</label>
                            </div>
                          )
                        })}
                      </>
                    }

                    {/* choices  state=choice  pref point idhi vuntey anni povali */}
                    {state.drawOdds?.choices.length > 0 &&
                      <>
                        {state.drawOdds?.choices.map((item, index) => {
                          return (
                            <>
                              <div className="checkbox" style={{ marginBottom: 10 }} key={index}>
                                <input
                                  type="radio"
                                  id={`choice-${index}`}
                                  checked={Choice === item}
                                  name="Choice"
                                  style={{ cursor: 'pointer' }}
                                  className="custom-radio"
                                  disabled={!huntPlannerFilterOptions?.huntResearch}
                                  value={item}
                                  onChange={(e) => {
                                    setChoice(item); // Update Choice state
                                    setExactPoints(false);
                                    setDrawChoice(''); // Uncheck DrawChoice
                                    setDrawPoints(0);
                                    onChangeOptions({ target: { name: "Choice", value: item } }); // Ensure state updates correctly
                                  }}
                                />
                                <label htmlFor={`choice-${index}`} style={{ marginBottom: 0 }}>{item}</label>
                              </div>
                            </>)
                        })}
                      </>
                    }


                    {DrawChoice && DrawPoints >= 1 ?
                      <div className="selected-draw-choice" >

                        {state.drawOdds?.points.length > 0 &&
                          <TableView tableData={state.drawOdds?.points} from='filter' DrawPoints={DrawPoints} ExactPoints={ExactPoints} DrawPercentage={DrawPercentage} />
                        }

                        {(DrawChoice == 'preference point') || (DrawChoice == 'max bonus point')
                          &&
                          <div style={{ width: '100%', display: 'flex', height: 30, alignItems: 'center', marginTop: 10 }}>
                            <input
                              type="checkbox"
                              id="ExactPoints"
                              checked={ExactPoints}
                              // checked={ExactPoints !== false}
                              disabled={DrawPoints == 0 || !huntPlannerFilterOptions?.huntResearch}
                              name="ExactPoints"
                              value={ExactPoints}
                              style={{ width: 20, height: 20, cursor: 'pointer' }}
                              onChange={(e) => {
                                const newValue = !ExactPoints;
                                setExactPoints(true);

                                if (newValue) {
                                  const customEvent = {
                                    target: {
                                      name: "ExactPoints",  // You can set it dynamically if needed
                                      value: true,
                                    }
                                  }
                                  setExactPoints(true)
                                  onChangeOptions(customEvent);
                                } else {
                                  setExactPoints(false)
                                  onChangeOptions(false, 'ExactPoints'); // Pass name explicitly when unchecked
                                }
                              }}
                            />
                            <label>Only show hunts requiring {DrawPoints} pts to draw</label>
                          </div>}
                      </div> :
                      null
                    }


                  </div>
                </div>
              }
            </div>


            {/* Trophy Potential Success Slider */}
            <div className="slider-section" style={{}}>
              <label>Trophy Potential</label>
              <div className="padding-child">
                <div
                  className={!huntPlannerFilterOptions?.huntResearch ? 'toggle-button disable-button disable-button-border-none' : 'toggle-button'}
                >{trophyPotential > 0 ? trophyPotential + "" : 'Any'}</div>
                <div className="margin-top-bottom-1em">
                  <input
                    name="trophyPotential"
                    type="range"
                    className={!huntPlannerFilterOptions?.huntResearch ? 'bg-color-light-gray' : ''}
                    disabled={!huntPlannerFilterOptions?.huntResearch}
                    min={state?.trophyPotential?.min} //"0"
                    max={state?.trophyPotential?.max} //"100"
                    value={trophyPotential}
                    style={{ background: !huntPlannerFilterOptions?.huntResearch ? '#959595' : '' }}
                    onChange={(e) => {
                      setTrophyPotential(e.target.value)
                      debouncedOnChangeOptions(e)
                    }}
                  />
                </div>

                <div className="slider-values">
                  <span>{state?.trophyPotential?.min?.toFixed(0)}"</span>
                  <span>{state?.trophyPotential?.max?.toFixed(0)}"</span>
                </div>
              </div>
            </div>

            {/* Public Land Success Slider */}
            <div className="slider-section" style={{}}>
              <label>Public Land %</label>
              <div className="padding-child">
                <div
                  className={!huntPlannerFilterOptions?.huntResearch ? 'toggle-button disable-button disable-button-border-none' : 'toggle-button'}
                >{publicLand > 0 ? publicLand + '%' : 'Any'}</div>
                <div className="margin-top-bottom-1em">
                  <input
                    name="publicLand"
                    type="range"
                    className={!huntPlannerFilterOptions?.huntResearch ? 'bg-color-light-gray' : ''}
                    disabled={!huntPlannerFilterOptions?.huntResearch}
                    min={state?.publicLand?.min > 0 ? state?.publicLand?.min : 0} // "0"
                    max={state.publicLand.max} //"100"
                    value={publicLand}
                    style={{ background: !huntPlannerFilterOptions?.huntResearch ? '#959595' : '' }}
                    onChange={(e) => {
                      setPublicLand(e.target.value);
                      // debounce(() => onChangeOptions(e), 1000);
                      debouncedOnChangeOptions(e)
                    }}
                  />
                </div>
                <div className="slider-values">
                  <span>{state?.publicLand?.min > 0 ? state?.publicLand?.min?.toFixed(0) : 0}%</span>
                  <span>{state?.publicLand?.max?.toFixed(0)}%</span>
                </div>
              </div>
            </div>

          </>}
      </div >
    </>

  );
};


const mapStateToProps = state => ({
  huntplannerStatesData: state.huntplannerStatesData,
  auth: state.auth,
  huntplannerMapReference: typeof state.huntplannerMapReference === 'function' ? state.huntplannerMapReference() : null,
  huntplannerMorefiltersState: state.huntplannerMorefilters,
  huntPlannerSelectedOtions: state.huntPlannerSelectedOtions,
  huntPlannerFilterOptions: state.huntPlannerFilterOptions
  // huntplannerMapReference: typeof state.mapReference === 'function' ? state.mapReference() : null, pavan

})

const mapDispatchToProps = dispatch => ({
  huntplannerMorefilters: (payload) => dispatch(huntplannerMorefilters(payload)),
  fetchGetFilterCount: (payload) => dispatch(fetchGetFilterCount(payload)),
  huntPlannerActiveOtions: (payload) => dispatch(huntPlannerActiveOtions(payload))
})

export default connect(mapStateToProps, mapDispatchToProps)(FilterComponent)

